import { render } from "./indexTemplateProposalComponent.vue?vue&type=template&id=62d49519&scoped=true"
import script from "./indexTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./indexTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./indexTemplateProposalComponent.vue?vue&type=style&index=0&id=62d49519&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d49519"]])

export default __exports__